import { Outlet } from 'react-router-dom'
import { Flex, useMatches } from '@mantine/core'

export function DefaultLayout() {
  const minHeight = useMatches({
    base: '100%',
    md: '100svh',
  })

  return (
    <Flex align="top" mih={minHeight}>
      <Outlet />
    </Flex>
  )
}
